// src/context/AppContext.js

import React, { createContext, useState, useEffect } from "react";
import { useAuthHeartbeat } from "../utils/heartBeat";

// Create global App context (currently for cart, expandable later)
export const AppContext = createContext();

const devLog = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.log(...args);
  }
};

export const AppProvider = ({ children }) => {
  const [cart, setCart] = useState(null);

  // 🔄 Heartbeat token refresh
  useAuthHeartbeat();

  // 🛒 Load cart from localStorage
  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      const cartData = localStorage.getItem("woo-gatsby-cart");
      const parsedCart = cartData ? JSON.parse(cartData) : null;
      setCart(parsedCart);

      devLog("🛒 Cart loaded:", parsedCart);
    } catch (err) {
      devLog("⚠️ Failed to load cart:", err);
    }
  }, []);

  return (
    <AppContext.Provider value={[cart, setCart]}>
      {children}
    </AppContext.Provider>
  );
};
